import React, { useState } from 'react';
import Image from 'next/image';
import { twMerge } from 'tailwind-merge';
import type { BaseCustomProps } from './types';

interface AssistantResponseProps extends BaseCustomProps {
  assistantName?: string;
  assistantAvatar?: string;
  type?: 'default' | 'info' | 'success' | 'warning';
}

export const AssistantResponse: React.FC<AssistantResponseProps> = ({ 
  children, 
  className,
  assistantName = 'Assistant',
  assistantAvatar,
  type = 'default'
}) => {
  const [imageError, setImageError] = useState(false);

  return (
    <>
      <div 
        className={twMerge(
          "block rounded-lg border-l-4 my-4 overflow-hidden", // Base styling
          type === 'info' ? "bg-[hsl(200,65%,95%)] border-[var(--teal)] text-[hsl(200,65%,30%)]" :
          type === 'success' ? "bg-[hsl(150,40%,95%)] border-[var(--moss)] text-[hsl(150,40%,30%)]" :
          type === 'warning' ? "bg-[hsl(20,80%,95%)] border-[var(--coral)] text-[hsl(20,80%,35%)]" :
          "bg-[hsl(220,15%,97%)] border-[hsl(220,20%,70%)] text-[hsl(220,15%,25%)]", // Default neutral styling
          className
        )}
      >
        {/* Assistant name header */}
        <div className="px-4 py-2 bg-black/5 border-b border-black/10">
          <div className="flex items-center gap-3">
            {assistantAvatar && !imageError ? (
              <Image 
                src={assistantAvatar} 
                alt={assistantName}
                width={24}
                height={24}
                className="rounded-full object-cover"
                onError={() => setImageError(true)}
              />
            ) : (
              <div className={`w-2 h-2 rounded-full bg-current opacity-60`}></div>
            )}
            <span className="text-sm font-medium opacity-80">
              {assistantName}
            </span>
          </div>
        </div>
        
        {/* Assistant response content */}
        <div className="px-4 py-3">
          {children}
        </div>
      </div>
    </>
  );
};

export default AssistantResponse;